<template>
  <div>
    <div v-for="(page, pageIndex) in printPages" :key="pageIndex" class="new-print-page">
      <table class="summary-row">
        <colgroup>
          <col class="col-no">
          <col class="col-entry-code">
          <col class="col-grid">
          <col class="col-grid-num">
          <col class="col-order">
          <col class="col-sorting">
          <col class="col-pic">
          <col class="col-info">
          <col class="col-ship-num">
          <col class="col-label-type">
          <col class="col-label-no">
          <col class="col-label-code">
          <col class="col-remark">
        </colgroup>
        <tbody>
          <tr>
            <td colspan="8" class="summary-cell title-cell">配送箱号：{{ page.boxNo }}</td>
            <td class="summary-cell total-cell">合计出货数：</td>
            <td class="summary-cell total-value">{{ page.total }}</td>
            <td colspan="3" class="summary-cell empty-cell"></td>
          </tr>
        </tbody>
      </table>
      <table class="new-list-table">
        <colgroup>
          <col class="col-no">
          <col class="col-entry-code">
          <col class="col-grid">
          <col class="col-grid-num">
          <col class="col-order">
          <col class="col-sorting">
          <col class="col-pic">
          <col class="col-info">
          <col class="col-ship-num">
          <col class="col-label-type">
          <col class="col-label-no">
          <col class="col-label-code">
          <col class="col-remark">
        </colgroup>
        <thead>
          <tr>
            <th>配送箱货物NO</th>
            <th>入库码/物流号</th>
            <th>库位</th>
            <th>库位包裹数</th>
            <th>订单号</th>
            <th>商品编号</th>
            <th>图片</th>
            <th>商品信息</th>
            <th>出货数</th>
            <th>标签类型</th>
            <th>标签号</th>
            <th>商品编码</th>
            <th>业务配送单单番备注</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rowIndex) in page.rows" :key="rowIndex" :class="{ 'empty-row': row.empty }">
            <td>{{ row.no }}</td>
            <td>
              <div v-for="(express, expressIndex) in row.expressList" :key="expressIndex">
                <p v-if="express.entryCode" style="font-weight: bold;">{{ express.entryCode }}</p>
                <p v-if="express.expressNo">WL:{{ express.expressNo }}</p>
              </div>
            </td>
            <td>{{ row.gridNumber }}</td>
            <td>{{ row.gridNum }}</td>
            <td>
              <p>{{ row.orderSn }}</p>
              <p v-if="row.pName">配货员:{{ row.pName }}</p>
            </td>
            <td>{{ row.sorting }}</td>
            <td>
              <img v-if="row.pic" :src="row.pic" alt="">
              <span v-else-if="!row.empty" class="pic-placeholder"></span>
            </td>
            <td class="info-cell">
              <p v-for="(info, infoIndex) in row.goodsInfo" :key="infoIndex">{{ info }}</p>
            </td>
            <td>{{ row.shipNum }}</td>
            <td>{{ row.labelType }}</td>
            <td>{{ row.labelNo }}</td>
            <td>{{ row.labelCode }}</td>
            <td class="remark-cell">{{ row.remark }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(
      {
        list: (state) => state.porderDetail.list,
        detail: (state) => state.porderDetail.detail,
      }
    ),
    printPages() {
      const rows = this.buildRows()
      return [{
        boxNo: this.getBoxNo(),
        total: this.getTotal(rows),
        rows: rows
      }]
    }
  },
  methods: {
    listValue(value) {
      if (!value || value == false) return []
      return Array.isArray(value) ? value : []
    },
    buildRows() {
      return this.listValue(this.list).map((item, index) => {
        const tags = this.listValue(item.porder_detail_tag)
        const firstTag = tags[0] || {}

        return {
          no: index + 1,
          expressList: this.getExpressList(item),
          gridNumber: this.getGridText(item, 'grid_number'),
          gridNum: this.getGridText(item, 'num'),
          orderSn: item.order_sn || '',
          pName: item.p_name || '',
          sorting: item.sorting || '',
          pic: item.pic || '',
          goodsInfo: this.getGoodsInfo(item),
          shipNum: item.num || item.wait_freight_num || '',
          labelType: firstTag.type || '',
          labelNo: firstTag.no || '',
          labelCode: firstTag.goods_no || '',
          remark: item.y_remark || ''
        }
      })
    },
    getGoodsInfo(item) {
      const detail = this.listValue(item.detail_y != false ? item.detail_y : item.detail)
      return detail.map(item => `${item.key || ''}: ${item.value || ''}`)
    },
    getExpressList(item) {
      return this.listValue(item.order_purchase).reduce((list, purchase) => {
        const expressList = this.listValue(purchase.order_purchase_express).map(express => ({
          entryCode: express.entry_code || '',
          expressNo: express.express_no || ''
        }))
        return list.concat(expressList)
      }, [])
    },
    getGridText(item, key) {
      return this.listValue(item.wms_stock).map(stock => {
        if (key == 'grid_number') {
          const floor = stock.wms_grid && stock.wms_grid.floor
          return [floor, stock.wms_grid_name].filter(value => value || value === 0).join('-')
        }
        return stock[key]
      }).filter(value => value || value === 0).join('\n')
    },
    getTotal(rows) {
      return rows.reduce((total, row) => total + (Number(row.shipNum) || 0), 0)
    },
    getBoxNo() {
      const porderSn = this.detail.porder_sn || ''
      const userText = this.detail.user_id || this.detail.realname || ''
      if (porderSn && userText) return `${porderSn}-${userText}`
      return porderSn
    }
  }
}
</script>

<style lang="scss" scoped>
.new-print-page {

  background: #ffffff;
  color: #000000;

  * {
    box-sizing: border-box;
  }
}

.summary-row {
  width: 100%;
  height: 22px;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 11px;
  font-weight: 600;
}

.summary-cell {
  padding: 0 5px;
  border: 0;
  vertical-align: middle;
}

.total-cell,
.total-value {
  text-align: center;
}

.total-cell {
  padding: 0 2px;
  font-size: 10px;
  white-space: nowrap;
}

.new-list-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 10px;
  line-height: 1.2;

  th,
  td {
    border: 1px solid #000000;
    vertical-align: middle;
    word-break: break-all;
  }

  th {
    height: 24px;
    padding: 2px 3px;
    color: #ffffff;
    background: #b51f28;
    font-size: 9px;
    font-weight: 600;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    word-break: keep-all;
  }

  td {
    height: 43px;
    padding: 3px 4px;
    white-space: pre-line;
  }

  th:first-child,
  td:first-child {
    padding-left: 2px;
    padding-right: 2px;
  }

  img,
  .pic-placeholder {
    display: block;
    width: 30px;
    height: 30px;
    margin: 0 auto;
    object-fit: cover;
    background: #d9d9d9;
  }

  p {
    margin: 0 0 2px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.info-cell,
.remark-cell {
  text-align: left;
}

.empty-row {
  color: transparent;
}

.col-no {
  width: 48px;
}

.col-entry-code {
  width: 80px;
}

.col-grid {
  width: 40px;
}

.col-grid-num {
  width: 41px;
}

.col-order {
  width: 91px;
}

.col-sorting {
  width: 37px;
}

.col-pic {
  width: 33px;
}

.col-info {
  width: 110px;
}

.col-ship-num {
  width: 45px;
}

.col-label-type {
  width: 52px;
}

.col-label-no {
  width: 62px;
}

.col-label-code {
  width: 88px;
}

.col-remark {
  width: 76px;
}
</style>
